module.exports = __webpack_public_path__ + "img/ring_y_e_1_null.b05e0b21.png";